<template>
    <div class="editcase">
        <mt-header :title="title" class="worktitle">
            <mt-button icon="back" slot="left" @click.native='$router.push("/addcase")'></mt-button>
        </mt-header>
        <div class="infobody">
            <div class="dataGroup">
                <p>作品名称<span style="color:red;font-weight:bold">*</span></p>
                <van-field  placeholder="输入作品名称" v-model="form.title" maxlength="20"/>
            </div>
            <div class="dataGroup">
                <p>所属行业<span style="color:red;font-weight:bold">*</span></p>
                <div style="display: flex;justify-content:space-between;align-items:center;" class="dataGroupdiv">
                    <van-field readonly clickable  placeholder="" @click="typeShow" input-align="right" v-model="form.industryName"/>
                    <van-icon name="arrow" @click="typeShow" />
                </div>
            </div>
            <div class="dataGroup">
                <p>工作职责<span style="color:red;font-weight:bold">*</span></p>
                <van-field  placeholder="输入您的职责" v-model="form.obligation" maxlength="20"/>
            </div>
            <div class="edit">
                <p class="name">作品图片<span style="color:red;font-weight:bold">*</span></p>
                <div class="imgs" v-for="(imgurl,index) in imgurl" :key="index">
                    <icon name='times-circle' @click.native='deleteWorksPhoto(imgurl.resId, imgurl.workPhotoId)'></icon>
                    <img :src="httpUrl + imgurl.resAddr">
                </div>
                <div class="addImg" @click='upImg' v-show="imgurl.length<5">
                    <van-icon name="plus" />
                    <p>点击上传</p>
                </div>
                <input id="upDataPart" type="file"  accept="image/*" value="上传" ref="upDataPart" @change="onFormChange($event)" enctype="multipart/form-data"/>
            </div>
            <div class="descrition">
                <p>作品描述<span style="color:red;font-weight:bold">*</span></p>
                <textarea id="desc" v-model="form.description" maxlength="500" placeholder="输入作品描述"></textarea>
            </div>
            <div class="dataGroup" style="margin-bottom:10px;">
                <p>作品链接</p>
                <van-field  placeholder="输入作品链接" v-model="form.link" maxlength="250"/>
            </div>
            <div style="height:57px;"></div>
        </div>
        <div class="next">
            <van-button type="info" @click="deleteAccountWorks(form.workId)" class="delete">删除</van-button>
            <van-button type="info" @click="save" v-preventReClick>保存</van-button>
        </div>
        <!-- 工作职责 -->
        <van-popup v-model="pickDuty" position="bottom">
            <van-picker show-toolbar :columns="workduty" @confirm="ondutyConfirm" @cancel="pickDuty = false"/>
        </van-popup>
    </div>
</template>

<script>
import { Toast, MessageBox, Indicator } from 'mint-ui'
import {preventReClick} from '../../assets/js/plugins'
export default {
    data(){
        return{
            title:'作品案例',
            form:{},
            pickDuty:false,
            workduty:[],
            imgurl:[],
            httpUrl:'',
            workId:'',
            // 案例图片ID
            workPhotoId: '',
        }
    },
    created(){
        this.$emit('footer', false);
        this.datainfo()
        if(this.$route.query.item){
            this.form=JSON.parse(this.$route.query.item)
            console.log(this.form)
            this.imgurl=this.form.workPhotoList
            this.workId=this.form.workId
        }
    },
    methods:{
        typeShow(){
            this.pickDuty=true
        },
        ondutyConfirm(value){
            this.form.industryName=value.text
            this.pickDuty=false
        },
        save(){
            let _this=this
            // _this.form.description=_this.form.description.replace(/\s/g,'')
            // console.log(_this.form.description,"__this.workPhotoId")
            if(_this.form.title===''||_this.form.title===undefined){
                Toast({
                    message: '请输入作品名称',
                    position: 'middle',
                    className: 'indexClass',
                    duration: 1000
                })
                return false
            }
            if(_this.form.industryName===''||_this.form.industryName===undefined){
                Toast({
                    message: '请选择所属行业',
                    position: 'middle',
                    className: 'indexClass',
                    duration: 1000
                })
                return false
            }
            if(_this.form.obligation===''||_this.form.obligation===undefined){
                Toast({
                    message: '请输入工作职责',
                    position: 'middle',
                    className: 'indexClass',
                    duration: 1000
                })
                return false
            }
            // 图片数量
            var pho = document.getElementsByClassName('imgs')
            if (pho.length <= 0) {
                Toast({
                    message: '请上传作品图片',
                    position: 'middle',
                    className: 'indexClass',
                    duration: 1000
                })
                return false
            }
            if(_this.form.description===''||_this.form.description===undefined){
                Toast({
                    message: '请输入作品描述',
                    position: 'middle',
                    className: 'indexClass',
                    duration: 1000
                })
                return false
            }
            if (_this.form.link) {
                var linkFormat = /^(http|https):\/\/([\w-]+\.)+[\w-]+([\w-./?%&=]*)?$/
                if (!linkFormat.test(_this.form.link)) {
                    Toast({
                        message: '作品链接请填写http开头的正确网址',
                        position: 'middle',
                        className: 'indexClass',
                        duration: 1000
                    })
                    return false
                }
            }
            this.axios({
                method: 'POST',
                url: '/url/account/userInfo/vueInsertAccountWorks',
                timeout: 100000,
                params: {
                    workId: _this.workId,
                    workPhotoId: _this.workPhotoId,
                    title:_this.form.title,
                    obligation:_this.form.obligation,
                    industryName: _this.form.industryName,
                    link:_this.form.link,
                    description:_this.form.description,
                    accountId:sessionStorage.getItem('loginId')
                }
            }).then(function (res) {
                if(res.data.success){
                    Toast({
                        message: '上传案例成功',
                        position: 'middle',
                        className: 'indexClass',
                        duration: 1000
                    })
                    _this.$router.push('/addcase')
                }else{
                    Toast({
                        message: '上传案例失败',
                        position: 'middle',
                        className: 'indexClass',
                        duration: 1000
                    })
                }
            }).catch(function (res) {
                Toast({
                    message: '上传案例失败',
                    position: 'middle',
                    className: 'indexClass',
                    duration: 1000
                })
            })
        },
        datainfo(){
            let _this = this
            function httpUrl () {
                return _this.axios.get('url/user/imgHttpUrl.json')
            }
            function loadSelect () {
                return _this.axios.get('url/account/userInfo/vueGetInfomationData')
            }
            Indicator.open({
                text: '加载中...',
                spinnerType: 'fading-circle'
            })
            _this.axios.all([httpUrl(),loadSelect()])
                .then(_this.axios.spread(function (imgurl, load) {
                    Indicator.close()
                    // -----图片服务器地址
                    _this.httpUrl = imgurl.data
                    load.data.works[0].children.forEach((item,index) => {
                        _this.workduty.push({id:index,text: item})
                    });
                }))
        },
        upImg: function () {
            this.$refs.upDataPart.click()
        },
        // 上传案例图片
        onFormChange: function (e) {
            let _this = this
            var pho = document.getElementsByClassName('imgs')
            if (pho.length >= 5) {
                Toast({
                    message: '只能上传五张图片',
                    position: 'middle',
                    className: 'indexClass',
                    duration: 1000
                })
                return false
            }
            if(e.target.files[0]){
                let file = e.target.files[0]
                let param = new FormData()
                param.append('file', file)
                param.append('imgSize', '5') // 额外参数设置
                this.axios({
                    method: 'post',
                    url: '/url/common/uploadImg',
                    timeout: 100000,
                    data: param
                }).then(function (response) {
                    if(response.data.success){
                        if (_this.workPhotoId === '') {
                            _this.workPhotoId += response.data.data.id
                        } else {
                            _this.workPhotoId += ',' + response.data.data.id
                        }
                        var img = {}
                        img.resId = response.data.data.id
                        img.workPhotoId = ''
                        img.resAddr = response.data.data.resaddr
                        _this.imgurl.push(img)
                    }else{
                        Toast({
                            message: response.data.msg,
                            position: 'middle',
                            className: 'indexClass',
                            duration: 1000
                        })
                    }
                }).catch(function (response) {
                    Toast({
                        message: '图片上传失败',
                        position: 'middle',
                        className: 'indexClass',
                        duration: 1000
                    })
                })
            }
        },
        deleteWorksPhoto: function (photoId, detWorkPhotoId) {
            var imgurlnew = []
            for (var i = 0; i < this.imgurl.length; i++) {
                if (this.imgurl[i].resId !== photoId) {
                    imgurlnew.push(this.imgurl[i])
                }
            }
            var photoIdStr = ''
            var workPhotoArr = this.workPhotoId.split(',')
            for (var j = 0; j < workPhotoArr.length; j++) {
                if (workPhotoArr[j] !== photoId) {
                    if (photoIdStr === '') {
                        photoIdStr += workPhotoArr[j]
                    } else {
                        photoIdStr += ',' + workPhotoArr[j]
                    }
                }
            }
            this.imgurl = imgurlnew
            this.workPhotoId = photoIdStr
            if (photoId !== '') {
                this.axios({
                    method: 'POST',
                    url: '/url/common/deleteImg',
                    timeout: 100000,
                    params: {
                        id: photoId
                    }
                    }).then(function (res) {
                        console.log('删除资源图片成功')
                    }).catch(function (res) {
                        console.log('删除资源图片失败')
                })
                if (detWorkPhotoId !== '') {
                    this.axios({
                        method: 'POST',
                        url: '/url/account/userInfo/deleteWorksPhoto',
                        timeout: 100000,
                        params: {
                            workPhotoId: detWorkPhotoId
                        }
                    }).then(function (res) {
                        console.log('删除作品图片成功')
                    }).catch(function (res) {
                        console.log('删除作品图片失败')
                    })
                }
            }
        },
        // 删除案例
        deleteAccountWorks(workId){
            let _this = this
            if (_this.workId !== '') {
                this.axios({
                    method: 'POST',
                    url: '/url/account/userInfo/deleteAccountWorks',
                    timeout: 100000,
                    params: {
                        workId:workId
                    }
                }).then(function (res) {
                    if(res.data.success){
                        _this.$router.push('/addcase')
                    }else{
                        Toast({
                            message: res.data.msg,
                            position: 'middle',
                            className: 'indexClass',
                            duration: 1000
                        })
                    }
                }).catch(function (res) {
                    console.log('错误：' + res)
                })
            }
        },
    }
}
</script>

<style>
    .worktitle .mint-header-title{
        height:100%;
        line-height: 40px;
    }
</style>
<style scoped>
    #desc{
        height: 200px;
        border: 1px solid #ddd;
        width:100%;
    }
    .infobody{
        margin-top:40px;
    }
    .infobody .dataGroup{
        border-bottom: 1px solid #ddd;
        padding:13px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .infobody .dataGroup p{
        font-size:14px;
        display: inline-block;
    }
    .infobody .dataGroup .select{
        display: inline-block;
        float:right;
        font-size:15px;
    }
    .dataGroupdiv .van-cell{
        display: inline-block;
        width: 100%;
        padding: 0;
    }
    .van-cell{
        display: inline-block;
        width: 70%;
        padding: 0;
    }
    .next{
        width:100%;
        position:fixed;
        bottom:0;
        background:#fff;
        padding:10px 0;
        text-align: center;
    }
    .next .van-button{
        width:40%;
        height:37px;
        border-radius: 5px;
        color:#fff;
    }
    .delete{
        background:#b0b2b3;
        border-color:#b0b2b3;
    }
    .editcase .mint-header{
        position:fixed;
        top:0;
        width:100%;
        z-index:1000;
    }
    .descrition{
        padding:0 10px;
    }
    .descrition p{
        margin:10px 0;
        font-size: 14px;
    }
    .descrition .van-cell{
        height: 200px;
        border: 1px solid #ddd;
        width:100%;
    } 
    .edit{
        padding:0 13px;
    }
    .edit .name{
        margin:10px 0;
        font-size: 14px;
    }
    .edit .imgs,.edit .addImg{
        display: inline-block;
        vertical-align: middle;
        text-align: center;
    }
    .edit .imgs{
        width: 75px;
        height: 75px;
        border: 1px solid #ccc;
        position: relative;
        margin-left: 5px;
    }
    .edit .imgs img{
        width: 100%;
        height: 100%;
    }
    .edit .imgs .fa-icon{
        position: absolute;
        top: -5px;
        right: -5px;
    }
    .edit .addImg{
        width: 75px;
        height: 75px;
        border: 1px dashed #ccc;
    }
    .edit .addImg p{
        font-size: 12px;
    }
    .edit .addImg .van-icon{
        margin-top: 15px;
    }
    #upDataPart{
        display: none;
    }
    .edit input{
        display: block;
        width: 100%;
        text-align: center;
        font-size: 14px;
        border: none;
        outline: none;
        border-bottom: 1px solid #d6d6d6;
        line-height: 30px;
    }
</style>


// WEBPACK FOOTER //
// editcase.vue?0ceec7ba